var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.heading)?_c('template',{slot:"header"},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.heading))])],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }